/**
 * The code snippet is a JavaScript object that contains properties and getter/setter methods.
 * It represents a context object with various properties such as moduleTitle, selected,
 * buttonLabel, and reply.
 * @type {{
 *    selected: {text: string, value: string},
 *    readonly getSelected: {text: string, value: string},
 *    changeSelected: {text: string, value: string},
 *    moduleTitle: null,
 *    readonly getModuleTitle: null,
 *    changeModuleTitle: string,
 *    reply: string,
 *    readonly getReply: string,
 *    changeReply: string,
 *    buttonLabel: string,
 *    changeButtonLabel: string,
 *    readonly getButtonLabel: string
 *    }}
 */
const ctx = {
  moduleTitle: null,
  get getModuleTitle() {
    return this.moduleTitle;
  },
  set changeModuleTitle(moduleTitle) {
    this.moduleTitle = moduleTitle;
  },
  selections: [],
  get getSelections() {
    return this.selections;
  },
  set changeSelections(selections) {
    this.selections = selections;
  },
  selected: {
    text: ' ',
    value: ' ',
  },
  get getSelected() {
    return this.selected;
  },
  set changeSelected(selected) {
    this.selected = selected;
  },
  sessionId: '',
  get getSessionId() {
    return this.sessionId;
  },
  set changeSessionId(sessionId) {
    this.sessionId = sessionId;
  },
  buttonLabel: ' ',
  get getButtonLabel() {
    return this.buttonLabel;
  },
  set changeButtonLabel(button) {
    this.buttonLabel = button;
  },
  reply: ' ',
  get getReply() {
    return this.reply;
  },
  set changeReply(rep) {
    this.reply = rep;
  },
  module: null,
  get getModule() {
    return this.module;
  },
  set changeModule(module) {
    this.module = module;
  },
  initialModule: null,
  get getInitialModule() {
    return this.initialModule;
  },
  set changeInitialModule(initialModule) {
    this.initialModule = initialModule;
  },
};

export default ctx;
